import { inject, observer } from "mobx-react";
import "styles/sharedStyles/statuses.scss";
import "./onecandidate.scss";

import iconAttention from "images/iconAttention.svg";

import Tooltip from "sharedComponents/Tooltip";
import { setTimeCreate, statusType } from "utils/functions";
import { sendMetriks } from "utils/metriks";

const OneCandidate = ({
  id,
  date_create,
  number,
  firstname,
  surname,
  patronymic,
  living_address,
  birthday,
  apllyInfo,
  status_id,
  vacancies_candidate_id_bring_data,

  setModalShowVacancies,
  setSelectedCandidate,
  getApplicationsForCandidate,
  getVacancies_for_candidate,

  statusesTitles,
  setIsCandidateModalOpen,
  cleanErrorAddition,
  getOneCandidate,
  setIsNewCandidate
}) => {
  return (
    <>
      <div className="candidate-card">
        <div className="candidate-card__header d-flex justify-content-between align-items-center">
          <p className="m-0">{setTimeCreate(date_create)}</p>
          {statusesTitles ? (
            <p
              className={`m-0 status status_${
                status_id && statusType(statusesTitles[status_id])
              }`}
            >
              {statusesTitles[status_id]}
            </p>
          ) : null}
        </div>
        <div className="candidate-card__body">
          <ul className="candidate-info-list w-100">
            <li className="d-flex justify-content-between align-items-center">
              <p
                className="candidate-info-list__fio w-50"
                onClick={async () => {
                  setSelectedCandidate(id);
                  cleanErrorAddition();
                  await getOneCandidate(id);
                  setIsCandidateModalOpen(true);
                  setIsNewCandidate(false);
                }}
              >
                {surname} {firstname} {patronymic}
              </p>
              {vacancies_candidate_id_bring_data ? (
                <div>
                  <img src={iconAttention} alt="" />
                </div>
              ) : null}
            </li>
            <li>
              <span>ID:</span>
              {number}
            </li>
            <li>
              <span>Дата рождения:</span>
              {birthday.split("-").reverse().join(".")}
            </li>
            <li>
              <span>Регион проживания:</span>
              {living_address}
            </li>
          </ul>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div>
            <Tooltip
              noIcon
              text={apllyInfo && apllyInfo.comment ? apllyInfo.comment : ""}
              openModal={apllyInfo.isApplyDisabled}
              Component={() => (
                <button
                  className={`candidate-card__btn candidate-card__btn_apply ${
                    apllyInfo.isApplyDisabled
                      ? "candidate-card__btn_apply-disabled"
                      : ""
                  }`}
                  onClick={() => {
                    if (!apllyInfo.isApplyDisabled) {
                      setSelectedCandidate(id);
                      getVacancies_for_candidate(id);
                      getApplicationsForCandidate({
                        candidate_id: id
                      });
                      setModalShowVacancies(true);
                      sendMetriks("reachGoal", "resp_2");
                    }
                  }}
                >
                  Откликнуться
                </button>
              )}
              position="top"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default inject(({ modalWindows, candidatesStore, vacanciesStore }) => {
  const { getVacancies_for_candidate } = vacanciesStore;

  const {
    setModalShowVacancies,

    setIsCandidateModalOpen,

    setAddNewCandidateModal
  } = modalWindows;
  const {
    setSelectedCandidate,
    getApplicationsForCandidate,
    cleanErrorAddition,
    setIsNewCandidate,
    getOneCandidate,
    statusesTitles
  } = candidatesStore;

  return {
    setModalShowVacancies,
    setSelectedCandidate,
    getApplicationsForCandidate,
    getVacancies_for_candidate,
    setIsCandidateModalOpen,

    cleanErrorAddition,

    setAddNewCandidateModal,
    setIsNewCandidate,
    getOneCandidate,
    statusesTitles
  };
})(observer(OneCandidate));
